var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWalletIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u06A9\\u06CC\\u0641_\\u067E\\u0648\\u0644",
    "data-name": "\\u06A9\\u06CC\\u0641 \\u067E\\u0648\\u0644",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3408",
    "data-name": "Rectangle 3408",
    width: 24,
    height: 24,
    transform: "translate(287 -117)",
    fill: "#333"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u06A9\\u06CC\\u0641_\\u067E\\u0648\\u0644-2",
    "data-name": "\\u06A9\\u06CC\\u0641 \\u067E\\u0648\\u0644",
    transform: "translate(-287 117)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "__TEMP__SVG__",
    transform: "translate(284.231 -119.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2421",
    "data-name": "Path 2421",
    d: "M11.694,19.691V9.848a2.462,2.462,0,0,1,2.463-2.463H25.523V6.155a2.454,2.454,0,0,0-2.44-2.463H5.308A2.494,2.494,0,0,0,2.769,6.115V23.423a2.493,2.493,0,0,0,2.539,2.423H23.077a2.45,2.45,0,0,0,2.44-2.463V22.154H14.151a2.461,2.461,0,0,1-2.457-2.463Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2422",
    "data-name": "Path 2422",
    d: "M14.135,10.731v8.077a.926.926,0,0,0,.923.923H25.846a.926.926,0,0,0,.923-.923V10.731a.926.926,0,0,0-.923-.923H15.058A.926.926,0,0,0,14.135,10.731Zm4.448,5.879a1.847,1.847,0,1,1,1.725-1.725,1.848,1.848,0,0,1-1.725,1.725Z",
    fill: "#333",
    opacity: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalletIcon);
export default __webpack_public_path__ + "static/media/walletIcon.972569f9d493429e6f10c92e3d320509.svg";
export { ForwardRef as ReactComponent };